import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONFIRM_MODAL: `${cleanedFilename(__filename)}-confirm-modal`,
};
